<template>
  <v-dialog v-bind="$attrs" width="380px">
    <v-card height="200px"
            class="dialogContainer">
      <v-btn
          class="closeButton"
          icon
          @click="showDeleteDialog"
          aria-label="close"
          :small="$vuetify.breakpoint.xs"
      >
        <v-icon>
          close
        </v-icon>
      </v-btn>
      <div>
        <v-card-title class="dialogTitle">
          Discard this notification?
        </v-card-title>
        <v-card-text class="px-6">
          This notification will be permanently deleted.
        </v-card-text>
      </div>
      <v-card-actions class="actionsContainer">
        <AdsButton
            button-text="Cancel"
            @click="showDeleteDialog"
            secondary
        />
        <AdsButton
          icon="delete"
            button-text="Discard"
            class="discardButton"
            color="#CE0037"
            @click="deleteItem"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { AdsButton } from '@nswdoe/doe-ui-core';
export default {
  name: 'DiscardDialog',
  components: {
    AdsButton
  },
  props: {
    deleteItem: Function,
    showDeleteDialog: Function
  }
}
</script>
<style lang="scss" scoped>

.dialogContainer {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;

  .closeButton {
    position:absolute;
    top: 8px;
    right: 8px;
  }

  .dialogTitle {
    font-weight: bold;
    padding: 16px 24px;
  }

  .actionsContainer {
    display: flex;
    justify-content: flex-end;
    padding: 0 24px 24px 24px;

    .discardButton {
      color: #FFFFFF;
      width: 120px;
    }
  }
}

</style>
